import { logger } from '../../../util/logger';
import { renderModel } from '../../../util/renderModel';
import { mediaClient } from '../../httpClient';
import { resolveUploadMimeType } from './constants';
import { UploadUrlResponse } from './types';

export const getUploadUrl = async (file: File, mediaAuthToken: string | null): Promise<UploadUrlResponse> => {
  try {
    const mimeType = resolveUploadMimeType(file);

    const { data } = await mediaClient.get<UploadUrlResponse>(
      `/site/media/files/upload/url?file_name=${file.name}&mime_type=${mimeType}`,
      {
        headers: {
          authorization: `APP ${mediaAuthToken}`,
        },
      },
    );

    return data;
  } catch (error) {
    logger.error({
      message: 'fail to get upload url and token',
      error,
      callParams: renderModel.get(),
    });
    throw error;
  }
};
